import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../numberUtils';
import './DisplayLineItem.scss';

/* Function parameter defaults replace deprecated React defaultProps. */
/* eslint-disable react/require-default-props */
function DisplayLineItem(_ref) {
  var id = _ref.id,
    _ref$hasDuration = _ref.hasDuration,
    hasDuration = _ref$hasDuration === void 0 ? false : _ref$hasDuration,
    viewDocumentUrl = _ref.viewDocumentUrl,
    _ref$documentName = _ref.documentName,
    documentName = _ref$documentName === void 0 ? null : _ref$documentName,
    date = _ref.date,
    optional_id = _ref.optional_id,
    description = _ref.description,
    hours = _ref.hours,
    minutes = _ref.minutes,
    total = _ref.total,
    _ref$feedback = _ref.feedback,
    feedback = _ref$feedback === void 0 ? null : _ref$feedback,
    _ref$showFeedback = _ref.showFeedback,
    showFeedback = _ref$showFeedback === void 0 ? false : _ref$showFeedback,
    index = _ref.index;
  return /*#__PURE__*/React.createElement("div", {
    id: "line-item-".concat(id),
    className: "line-item display-line-item-full-width ".concat(index % 2 === 1 ? 'even-row' : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "display-line-item g-row--always ".concat(showFeedback && feedback ? 'with-feedback' : '')
  }, showFeedback && feedback && /*#__PURE__*/React.createElement("i", {
    className: "edits-requested-indicator fa fa-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "date ".concat(showFeedback && feedback ? 'with-feedback' : '')
  }, date), /*#__PURE__*/React.createElement("div", {
    className: "optional-id"
  }, optional_id), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, description), hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "hours-and-minutes"
  }, hours, ' ', "h", ' ', minutes, ' ', "min"), /*#__PURE__*/React.createElement("div", {
    className: "total"
  }, formatCurrency(total)), !hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "file"
  }, documentName && /*#__PURE__*/React.createElement("a", {
    href: viewDocumentUrl,
    "data-turbo": "false"
  }, documentName))), showFeedback && feedback && /*#__PURE__*/React.createElement("div", {
    className: "line-item-feedback body-text-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "medium-weight pb-8"
  }, "Comments"), /*#__PURE__*/React.createElement("div", null, feedback)));
}
DisplayLineItem.propTypes = {
  id: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  optional_id: PropTypes.string.isRequired,
  hours: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  hasDuration: PropTypes.bool,
  viewDocumentUrl: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  documentName: PropTypes.string,
  feedback: PropTypes.string,
  showFeedback: PropTypes.bool,
  index: PropTypes.number.isRequired
};
export default DisplayLineItem;